var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlzatineGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1142 4039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.908,338.5l12.841-10.227V317.5h-3.8l-15.7,3.818V338.5Z",
    transform: "translate(914 -4355)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.659,
    height: 17.182,
    transform: "translate(1144.25 -4033.682)",
    fill: "none",
    stroke: "#aeaeae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.953
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.25,321.318l15.695-3.818h3.805v10.773L236.909,338.5",
    transform: "translate(914 -4355)",
    fill: "none",
    stroke: "#aeaeae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.953
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.841,
    y2: 3.818,
    transform: "translate(1150.909 -4037.5)",
    fill: "none",
    stroke: "#aeaeae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.953
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(1142 -4039)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlzatineGrey);
export default __webpack_public_path__ + "static/media/alzatine_grey.0b2af04d456f79afa9af2f1e94bdd448.svg";
export { ForwardRef as ReactComponent };